import './loading.css';

const LoadingPage = () => {
  return (
    <div id="preloader">
      <div className="preloader-spin"></div>
    </div>
  );
};

export default LoadingPage;
